(ns dashboard.views.questionnaire.question-list.config
  (:require
   [dashboard.entity.question.db :as question.db]
   [reitit.frontend.easy :as rfe]))

(def view-id
  :route.view/questionnaire-question-list)

(defn breadcrumbs [{:keys [id title]}]
  [{:href (rfe/href :route.view/home) :label "Dashboard"}
   {:href (rfe/href :route.view/questionnaires) :label "Questionnaires"}
   {:href (rfe/href view-id {:questionnaire-id id})
    :label title
    :active? true}])

(def app-db-key question.db/question-list--app-db-key)
